// frontend/src/api/customerApi.js
import api from './api';

/** Get all customers */
export const getCustomers = () => {
  return api.get('/customers');
};

/** Create a new customer */
export const createCustomer = (customerData) => {
  return api.post('/customers', customerData);
};

/** Get a customer by ID */
export const getCustomerById = (id) => {
  return api.get(`/customers/${id}`);
};

/** Update a customer by ID */
export const updateCustomer = (id, customerData) => {
  return api.put(`/customers/${id}`, customerData);
};

/** Delete a customer by ID */
export const deleteCustomer = (id) => {
  return api.delete(`/customers/${id}`);
};

/** 
 * Helper to convert a deal object { productName, SKU, quantity, ... } 
 * into multipart/form-data. This is needed if we have a PDF (receipt) 
 * to upload.
 */
function buildDealFormData(dealData) {
  const formData = new FormData();
  Object.entries(dealData).forEach(([key, value]) => {
    formData.append(key, value);
  });
  return formData;
}

/** Add a new deal to a customer (POST /customers/:id/deals) */
export const addDeal = (customerId, dealData) => {
  const formData = buildDealFormData(dealData);
  return api.post(`/customers/${customerId}/deals`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

/** Update an existing deal (PUT /customers/:id/deals/:dealId) */
export const updateDeal = (customerId, dealId, dealData) => {
  const formData = buildDealFormData(dealData);
  return api.put(`/customers/${customerId}/deals/${dealId}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

/** Delete a deal (DELETE /customers/:id/deals/:dealId) */
export const deleteDeal = (customerId, dealId) => {
  return api.delete(`/customers/${customerId}/deals/${dealId}`);
};
/** get the pdf */
export const getDealReceipt = (customerId, dealId) => {
  // We expect a binary PDF back, so set `responseType` to 'arraybuffer' or 'blob'.
  return api.get(`/customers/${customerId}/deals/${dealId}/receipt`, {
    responseType: 'arraybuffer', 
  });
};
